




















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, Getter, namespace } from 'vuex-class';
import PieChart from "@/components/chart/PieChart.vue";
import { ProductAggregatedStatUruchomieniaSum } from "@/store/modules/statsUruchomienia/types";
import { ProductAggregatedStatPobraniaSum } from "@/store/modules/statsPobrania/types";
import { ProductAggregatedStatDeklaracjeSum } from "@/store/modules/statsDeklaracje/types";
import { Product } from "@/pitprojekt/models/Product";
import { Utils } from '@/pitprojekt/utils';
import { EventBus } from "@/pitprojekt/event-bus";
const StatsUruchomieniaModule = namespace('StatsUruchomieniaModule')
const StatsPobraniaModule = namespace('StatsPobraniaModule')
const StatsDeklaracjeModule = namespace('StatsDeklaracjeModule')
const SettingsModule = namespace('SettingsModule')
import _ from 'lodash'

@Component({
    components: { PieChart }
})
export default class StatsGeneralChart extends Vue {
    @Prop(Object) chartData!: object
    @SettingsModule.Getter('selectedProducts') selectedProducts!: Array<number>;
    @SettingsModule.Getter('currentUserProducts') currentUserProducts!: Array<Product>;
    @SettingsModule.Getter('lastYear') lastYear!: boolean;

    @StatsUruchomieniaModule.Getter('aggregatedStatsUruchomieniaSum') aggregatedStatsUruchomieniaSum! :Array<ProductAggregatedStatUruchomieniaSum>;
    @StatsUruchomieniaModule.Getter('aggregatedStatsUruchomieniaSumUpdating') aggregatedStatsUruchomieniaSumUpdating! :boolean;
    @StatsUruchomieniaModule.Action('updateAggregatedStatsUruchomieniaSum') updateAggregatedStatsUruchomieniaSum: any;

    @StatsPobraniaModule.Getter('aggregatedStatsPobraniaSum') aggregatedStatsPobraniaSum! :Array<ProductAggregatedStatPobraniaSum>;
    @StatsPobraniaModule.Getter('aggregatedStatsPobraniaSumUpdating') aggregatedStatsPobraniaSumUpdating! :boolean;
    @StatsPobraniaModule.Action('updateAggregatedStatsPobraniaSum') updateAggregatedStatsPobraniaSum: any;

    @StatsDeklaracjeModule.Getter('aggregatedStatsDeklaracjeSum') aggregatedStatsDeklaracjeSum! :Array<ProductAggregatedStatDeklaracjeSum>;
    @StatsDeklaracjeModule.Getter('aggregatedStatsDeklaracjeSumUpdating') aggregatedStatsDeklaracjeSumUpdating! :boolean;
    @StatsDeklaracjeModule.Action('updateAggregatedStatsDeklaracjeSum') updateAggregatedStatsDeklaracjeSum: any;

    chartOptions :object = {
        legend: {
            display: true
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.chartClickHandler
    };

    chartClickHandler(point: any, event: any) {
        let item = event[0];
        if (item != undefined) {
            let index = item._index;
            let chartData:any = this.aggregatedStatsChartData;
            let productId = chartData.labels[index].replace('#', '');
            this.goToStatsOfSelectedProduct(productId);
        }
    }

    chipClickHandler(productId: string) {
        this.goToStatsOfSelectedProduct(productId);
    }

    goToStatsOfSelectedProduct(productId: string) {
        switch (this.simpleRouteName) {
            case 'uruchomienia':
                this.$router.push({ name: 'stats-uruchomienia-product', params: { id: productId } });
                break;

            case 'pobrania':
                this.$router.push({ name: 'stats-pobrania-product', params: { id: productId } });
                break;

            case 'deklaracje':
                this.$router.push({ name: 'stats-deklaracje-product', params: { id: productId } });
                break;
        }
    }

    get simpleRouteName(): string {
        return Utils.getSimpleRouteName(this.$route.name);
    }

    get isLoading() {
        switch (this.simpleRouteName) {
            case 'uruchomienia': return this.aggregatedStatsUruchomieniaSumUpdating;
            case 'pobrania': return this.aggregatedStatsPobraniaSumUpdating;
            case 'deklaracje': return this.aggregatedStatsDeklaracjeSumUpdating;
            default: return false;
        }
    }

    created() {
        this.updateAggregatedStatsSum();
        EventBus.$on('PageTitleDateChangedEvent', this.pageTitleDateChanged);
    }

    beforeDestroy() {
        EventBus.$off('PageTitleDateChangedEvent', this.pageTitleDateChanged);
    }

    pageTitleDateChanged() {
         this.updateAggregatedStatsSum(true);
    }

    updateAggregatedStatsSum(forceUpdate: boolean = false) {
        switch (this.simpleRouteName) {
            case 'uruchomienia':
                this.updateAggregatedStatsUruchomieniaSum({'forceUpdate': forceUpdate, 'lastYear': this.lastYear});
                break;

            case 'pobrania':
                this.updateAggregatedStatsPobraniaSum({'forceUpdate': forceUpdate, 'lastYear': this.lastYear});
                break;

            case 'deklaracje':
                this.updateAggregatedStatsDeklaracjeSum({'forceUpdate': forceUpdate, 'lastYear': this.lastYear});
                break;
        }
    }


    get aggregatedStatsChartData(): object {
        return {
            'labels': this.labelsFromAggregatedStats(),
            'datasets': [{
                'label': this.headerText(),
                'backgroundColor': Utils.rGbMdColorsArray(this.aggregatedStatsSum.length, '0.6'),
                'borderColor': Utils.rGbMdColorsArray(this.aggregatedStatsSum.length),
                'borderWidth': 1,
                'pointBackgroundColor': 'white',
                'data': _.map(this.aggregatedStatsForSelectedProducts, 'stat')
            }]
        };
    }

    get aggregatedStatsSum(): Array<any> {
        switch (this.simpleRouteName) {
            case 'uruchomienia': return this.aggregatedStatsUruchomieniaSum;
            case 'pobrania': return this.aggregatedStatsPobraniaSum;
            case 'deklaracje': return this.aggregatedStatsDeklaracjeSum;
            default: return [];
        }
    }

    headerText(): string {
        switch (this.simpleRouteName) {
            case 'uruchomienia': return 'Statystyki uruchomień produktów';
            case 'pobrania': return 'Statystyki pobrań produktów';
            case 'deklaracje': return 'Statystyki wpływów z 1%';
            default: return '?';
        }
    }

    labelsFromAggregatedStats() :Array<string> {
        let labels: Array<string> = [];
        switch (this.simpleRouteName) {
            case 'uruchomienia':
                this.aggregatedStatsUruchomieniaSum.forEach(function(productAggregatedStat :ProductAggregatedStatUruchomieniaSum) {
                    labels.push('#' + productAggregatedStat.productId);
                });
                break;

            case 'pobrania':
                this.aggregatedStatsPobraniaSum.forEach(function(productAggregatedStat :ProductAggregatedStatPobraniaSum) {
                    labels.push('#' + productAggregatedStat.productId);
                });
                break;

            case 'deklaracje':
                this.aggregatedStatsDeklaracjeSum.forEach(function(productAggregatedStat :ProductAggregatedStatDeklaracjeSum) {
                    labels.push('#' + productAggregatedStat.productId);
                });
                break;
        }

        return labels;
    }

    get aggregatedStatsForSelectedProducts(): Array<any> {
        let selectedProducts = this.selectedProducts;
        return _.filter(this.aggregatedStatsSum, function(o) { return _.includes(selectedProducts, o.productId); });
    }

    getProductIconName(productId: number): string {
        let product: Product|undefined = _.find(this.currentUserProducts, {'id': productId});
        return  (product != undefined) ? Utils.getProductIconName(product.rodzaj) : 'help';
    }

    @Watch('$route', { immediate: true, deep: true })
    updateRoute() {
        this.updateAggregatedStatsSum();
    }

}
